module.exports = __webpack_public_path__ + "static/media/jenny3.5da07de4.png";